import { LayerCorners } from '../../../../../../inspector'
import { capitalize, roundWithLocale } from '@sketch/utils'

interface Args {
  radius: string | number
  type: LayerCorners['type']
  smoothing?: number
}

const copy = ({ radius, type, smoothing }: Args) =>
  `Radius: ${radius}${type ? `\nStyle: ${capitalize(type)}` : ''}${smoothing ? `\nSmoothing: ${roundWithLocale(smoothing, 2)}%` : ''}`

export default copy
